import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./main/main.module').then((mod) => mod.MainModule),
  },
  { 
    path: '**', 
    redirectTo: '' 
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', useHash: true }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
